import { useApi } from 'api/api-context';

export type DepartmentUiMode = 'legacy' | 'tree';

/** One presentation decision for the effective authenticated or impersonated user. */
export default function useDepartmentUiMode(): { mode: DepartmentUiMode; pending: boolean } {
  const { jwt, ready, legacyDepartmentUi } = useApi();
  return {
    mode: ready && legacyDepartmentUi === true ? 'legacy' : 'tree',
    pending: Boolean(jwt) && !ready,
  };
}
